// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"0aacffe4","341":"0aacffe4","508":"0aacffe4","726":"0aacffe4"}[chunkId] + ".chunk.css";
};